import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../base/Logo';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const navLinks = [
    { name: 'About', path: '/about' },
    { name: 'MAS Academy', path: '/mas-academy' },
    { name: 'Blog', path: '/blog' },
    { name: 'Join', path: '/join' },
    { name: 'Donate', path: '/donate' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    if (!isHomePage) {
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-charcoal shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            className="flex items-center gap-3 cursor-pointer group whitespace-nowrap"
          >
            <div className="flex items-center gap-3">
              <Logo variant="crown" className="w-10 h-10" color="#E6007E" />
              <h3 className="font-poppins font-bold text-2xl text-white">MASDEUNA</h3>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/about"
              className="font-inter font-medium text-sm text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
            >
              ABOUT
            </Link>
            <Link
              to="/mas-academy"
              className="font-inter font-medium text-sm text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
            >
              MAS ACADEMY
            </Link>
            <Link
              to="/donate"
              className="font-inter font-medium text-sm text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
            >
              DONATE
            </Link>
            <button
              onClick={() => scrollToSection('join')}
              className="bg-primary hover:bg-primary/90 text-white font-inter font-semibold px-6 py-3 rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              JOIN US
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
